<div class="common-modal__container">
    <!-- Cabecera -->
    <div class="common-modal__header">
      <span class="common-modal__text-header"
        [afTranslate]="'blocked-edition-modal.title-header'">
        _Bloqueo de la edición en función del proceso
      </span>
    </div>
    <!-- Contenedor -->
    <div class="common-modal__content-scroll">
      <p class="common-modal__content-header-info"
        [afTranslate]="'blocked-edition-modal.info-modal'">
        _No se han podido subir algunos documentos. Si quieres, puedes intentarlo de nuevo antes de continuar.
      </p>
      <div class="upload-document__form-container">
        <field-type-list-extended [field]="blockedEditionModal.processStates"
          [preSelectItem]="processStatesSelected"
          [listValues]="blockedEditionModal.processStatesList"
          (itemSelected)="processSelected($event)">
        </field-type-list-extended>
      </div>
    </div>
    <div class="common-modal__footer">
      <button class="common-button__text-border"
        (click)="handleDismiss()">
        <span class="common-button__text-title"
          [afTranslate]="'common.cancel'">_cancelar
        </span>
      </button>
      <button class="common-button__text"
        (click)="handleAccept()">
        <span class="common-button__text-title"
          [afTranslate]="'common.save'">
          _guardar
        </span>
      </button>
    </div>
</div>
